import { HttpContextToken } from '@angular/common/http';

/**
 * Punto de extensión: marca una petición que lleva SU PROPIA sesión (distinta de la del panel). Los interceptores del
 * panel no le añaden el contexto de empresa/módulo ni intentan renovar la sesión del panel ante un 401. Quien construye
 * la petición (otra librería con su propio esquema de sesión) la fija; el panel nunca la usa.
 */
export const OWN_SESSION_REQUEST = new HttpContextToken<boolean>(() => false);
